export enum REQUEST_STATE {
    NONE = 'NONE',
    LOADING = 'LOADING',
    OK = 'OK',
    ERROR = 'ERROR',
}
